import { Box, LinearProgress, Typography } from "@mui/material";
import { real } from "../../core/loja";

type BalanceProgressBarProps = {
  total: number;
  current: number;
};

function BalanceProgressBar({ total, current }: BalanceProgressBarProps) {
  const percentage = Math.min((current / total) * 100, 100);

  return (
    <Box
      position="relative"
      width="100%"
      sx={{
        maxWidth: {
          xs: "100%",
          sm: 400,
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="end"
        mb={0.1}
      >
        <Typography fontWeight="bold" sx={{ fontSize: 15, color: "#737376" }}>
          Limite Disponível <b>{real.format(current)}</b>
        </Typography>
        <Typography color="text.secondary" sx={{ fontSize: 13, color: "#666" }}>
          de {real.format(total)}
        </Typography>
      </Box>

      <LinearProgress
        variant="determinate"
        value={percentage}
        sx={{
          height: 10,
          width: "100%",
          borderRadius: 5,
          backgroundColor: "#ccc",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#333647",
            borderRadius: 5,
          },
        }}
      />
    </Box>
  );
}

export default BalanceProgressBar;
